// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum FIRESTORE_COLLECTION {
    treasureChestItems = 'treasure-chest-items',
    treasureChestThemes = 'treasure-chest-themes',
    treasureChestAuthors = 'treasure-chest-authors',
    treasureChestTypes = 'treasure-chest-types',
    treasureChestItemUploader = 'treasure-chest-item-uploader',
    // Production
    posts = 'posts',
    users = 'users',
    annotations = 'annotations',
    annotationEngagement = 'annotation-engagement',
    annotationEvents = 'annotation-events',
    media = 'media',
    userActions = 'user-actions',
    mailingListRequests = 'notification-requests',
    userSessions = 'user-sessions',
    mail = 'mail',
    mailTracking = 'mail-tracking',
    sales = 'sales',
    chargebacks = 'chargebacks',
    checkoutSessions = 'checkout-sessions',
    checkoutSessionCartAbandonment = 'checkout-session-cart-abandonment',
    checkoutSessionCartAbandonmentUsers = 'checkout-session-cart-abandonment-users',
    notifications = 'notifications',
    saleNegotiationRequests = 'sale-negotiation-requests',
    dailyDigests = 'daily-digests',
    readerChapterProgressHistory = 'reader-chapter-progress-history',
    postCollabDocs = 'post-collab-docs',
    postChapters = 'post-chapters',
    postSections = 'post-sections',
    postEngagement = 'post-engagement',
    postUpdateEvents = 'post-update-events',
    idempotencyKeys = 'idempotency-keys',
    functionOverrides = '_function-overrides',
    functionEventLocks = '_function-event-locks',
    audioOffloadExecutions = '_audio-offload-executions',
    audioTranscriptionJobs = '_audio-transcription-jobs',
    postAudioDerivativeJobs = '_post-audio-derivative-jobs',
    imageMetadataJobs = '_image-metadata-jobs',
    taxTransactionBackfillJobs = '_tax-transaction-backfill-jobs',
    receiptBackfillJobs = '_receipt-backfill-jobs',
    postAudioPreviewRepairJobs = '_post-audio-preview-repair-jobs',
    postAudioPreviewAssetIndex = '_post-audio-preview-asset-index',
    stripeCustomerAttachRetryJobs = '_stripe-customer-attach-retry-jobs',
    // Tracks async annotation fan-out progress for idempotent background retries.
    annotationFanoutStatus = 'annotation-fanout-status',
    // Staging
    stagingPosts = 'staging-posts',
    stagingUsers = 'staging-users',
    stagingAnnotations = 'staging-annotations',
    stagingAnnotationEngagement = 'staging-annotation-engagement',
    stagingAnnotationEvents = 'staging-annotation-events',
    stagingMedia = 'staging-media',
    stagingUserActions = 'staging-user-actions',
    stagingMailingListRequests = 'staging-notification-requests',
    stagingUserSessions = 'staging-user-sessions',
    stagingMailTracking = 'staging-mail-tracking',
    stagingSales = 'staging-sales',
    stagingChargebacks = 'staging-chargebacks',
    stagingCheckoutSessions = 'staging-checkout-sessions',
    stagingCheckoutSessionCartAbandonment = 'staging-checkout-session-cart-abandonment',
    stagingCheckoutSessionCartAbandonmentUsers = 'staging-checkout-session-cart-abandonment-users',
    stagingNotifications = 'staging-notifications',
    stagingSaleNegotiationRequests = 'staging-sale-negotiation-requests',
    stagingReaderChapterProgressHistory = 'staging-reader-chapter-progress-history',
    stagingPostCollabDocs = 'staging-post-collab-docs',
    stagingPostChapters = 'staging-post-chapters',
    stagingPostSections = 'staging-post-sections',
    stagingPostEngagement = 'staging-post-engagement',
    stagingPostUpdateEvents = 'staging-post-update-events',
    stagingIdempotencyKeys = 'staging-idempotency-keys',
    stagingFunctionEventLocks = 'staging-function-event-locks',
    stagingAudioOffloadExecutions = 'staging-audio-offload-executions',
    stagingAudioTranscriptionJobs = 'staging-audio-transcription-jobs',
    stagingPostAudioDerivativeJobs = 'staging-post-audio-derivative-jobs',
    stagingImageMetadataJobs = 'staging-image-metadata-jobs',
    stagingTaxTransactionBackfillJobs = 'staging-tax-transaction-backfill-jobs',
    stagingReceiptBackfillJobs = 'staging-receipt-backfill-jobs',
    stagingPostAudioPreviewRepairJobs = 'staging-post-audio-preview-repair-jobs',
    stagingPostAudioPreviewAssetIndex = 'staging-post-audio-preview-asset-index',
    stagingStripeCustomerAttachRetryJobs = 'staging-stripe-customer-attach-retry-jobs',
    // Staging mirror of async annotation fan-out status tracking.
    stagingAnnotationFanoutStatus = 'staging-annotation-fanout-status',
}
